import React, { useMemo } from 'react'
import T from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useTranslation } from 'react-i18next'

import PageTitle from 'components/atoms/PageTitle'
import IconButton from 'components/atoms/IconButton'

export default function CarDetailsPageTitle({
  setShowDetails,
  label,
  cars,
  vin,
}) {
  const { t } = useTranslation()

  const next = useMemo(() => {
    for (let i = 0; i < cars.length; i++) {
      if (cars[i].vin === vin) {
        return cars[i + 1]?.vin
      }
    }
  }, [cars, vin])

  const previous = useMemo(() => {
    for (let i = 1; i < cars.length; i++) {
      if (cars[i].vin === vin) {
        return cars[i - 1]?.vin
      }
    }
  }, [cars, vin])

  return (
    <Box display="flex" direction="row" justifyContent="space-between">
      <PageTitle
        label={
          <Stack direction="row" alignItems="center">
            <IconButton onClick={() => setShowDetails(false)}>
              <ChevronLeftIcon />
            </IconButton>
            <Box mr={2} />
            <Typography variant="h4">
              <strong>{label || t('carDetails.title')}</strong>
            </Typography>
          </Stack>
        }
      />
      <Stack direction="row" alignItems="center">
        {previous && (
          <IconButton onClick={() => setShowDetails(previous)}>
            <ChevronLeftIcon />
          </IconButton>
        )}
        {previous && next && <Box pr={1} />}
        {next && (
          <IconButton onClick={() => setShowDetails(next)}>
            <ChevronRightIcon />
          </IconButton>
        )}
      </Stack>
    </Box>
  )
}

CarDetailsPageTitle.propTypes = {
  label: T.string,
  linkTo: T.string,
}
